import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import OrganizationOverview from './modules/admin/organization/Overview';
import OrganizationCreateOrEdit from './modules/admin/organization/CreateOrEdit';
import Settings from './modules/admin/organization/Settings';
import AlertMessage from './modules/admin/organization/AlertMessage';
import ManageAdmins from './modules/admin/organization/ManageAdmins';
import AlertInfoMessage from './modules/admin/organization/AlertInfoMessage';
import Mail from './modules/admin/organization/Mail';
import Admin from './modules/admin/organization/Admin';
import Login from './modules/user/Login';
import './App.css';
import ReportDonationsInfo from './modules/reports/ReportDonationsInfo';

const Notfound = () => (
	<h1>Ikke fundet</h1>
	);

const App = () => (
   	<Router>
   		<Switch>
            <Route component={OrganizationCreateOrEdit} path="/admin/organization/:id/edit" exact />
      		<Route component={OrganizationCreateOrEdit} path="/admin/organization/:id/edit/:new" exact />
      		<Route component={OrganizationCreateOrEdit} path="/admin/organization/create" exact />
      		<Route component={ReportDonationsInfo} path="/admin/organization/:id/donations/year/:year" exact />
            <Route component={OrganizationOverview} path="/admin/organizations" exact />
            <Route component={Settings} path="/admin/organizations/settings" exact />
            <Route component={AlertMessage} path="/admin/organizations/settings/alert" exact />
            <Route component={ManageAdmins} path="/admin/organizations/settings/administrators" exact />
            <Route component={AlertInfoMessage} path="/admin/organizations/settings/alert-info" exact />
      		<Route component={Mail} path="/admin/organizations/settings/mail" exact />
      		<Route component={Admin} path="/admin" exact />
            <Route component={Login} path="/login" exact />
      		<Route component={Login} path="/" exact />
      		<Route component={Notfound}/>
      	</Switch>
    </Router>
);

export default App;


// WEBPACK FOOTER //
// ./src/App.js